<template>
  <div class="container">
    <div class="title">成为CMDHRA平台会员
      <p>尊敬的学员：您好！</p></div>
    <div class="content">
      <p>感谢您对CMDHRA的关注。</p>
      <p>平台负责人：邹志超  13511001396</p>
      <p>主编：黄凯</p>
      <p>运营：张雪瑞</p>
      <p>商务合作/企业会员：</p>
      <p>郭江凤  18612997284 guojiangfeng@medcircle.cn</p>
      <p>李强  13301177736</p>
    </div>

  </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped lang="scss">
  .container{
    margin: .4rem;
    .title{
      font-size: .5rem;
      p{
        margin-top: .5rem;
      }
    }
    .content{
    margin-left: .5rem;
  }
  }
p{
  font-size:.32rem ;
  line-height: .7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/member/index.vue